// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"594":"f6945e5e","640":"37d7cbba"}[chunkId] + ".js";
};